import React, { Fragment } from 'react';
import { IStaticLocale } from '@/interfaces/staticlocale';
import { IPagesWithCategories } from '@/interfaces/page';
import { classNames } from '@/shared/helpers';
import wrappedMenuIcon from '@/static/images/wrappedMenu.png';
import { InternalOrExternalPage } from '@/components/Headers/MainHeader/Atoms/InternalOrExternalPage';
import Page from './components/Page';

import './styles.scss';

type Props = {
  pathLang: string;
  locale: IStaticLocale;
  pages: IPagesWithCategories[];
  wrappedPages: IPagesWithCategories[];
  shouldApplyContrast: boolean;
  language: string;
};

const Pages = (props: Props) => {
  const {
    pathLang,
    locale,
    pages,
    shouldApplyContrast,
    wrappedPages,
    language,
  } = props;

  return (
    <>
      {pages.map((page, index) => {
        return page.isCategory ? (
          <Fragment key={index}>
            {page.products.length > 0 ? (
              <li className="navbar-list-item">
                <Page
                  pathLang={pathLang}
                  language={language}
                  locale={locale}
                  page={page}
                />
              </li>
            ) : null}
          </Fragment>
        ) : (
          <li key={index} className="navbar-list-item">
            <InternalOrExternalPage page={page} pathLang={pathLang} />
          </li>
        );
      })}

      {wrappedPages.length > 0 ? (
        <li className="wrap-menu">
          <img
            src={wrappedMenuIcon}
            alt={locale.header.wrapped_icon_menu}
            className={classNames(shouldApplyContrast && 'image-with-contrast')}
          />

          <ul className="anim-drop-down wrapped-content">
            {wrappedPages.map((page, index) => (
              <li
                key={index}
                className="anim-drop-down-item wrapped-content-item"
              >
                <InternalOrExternalPage page={page} pathLang={pathLang} />
              </li>
            ))}
          </ul>
        </li>
      ) : null}
    </>
  );
};

export default Pages;
